<template>
  <div class="alert">
    <v-alert 
      transition="slide-y-reverse-transition"
      v-model="item.alert"
      v-for="(item, i) in alerts"
      :key="i"
      :type="item.type" 
      :icon="item.type == 'error' ? 'fas fa-exclamation-circle' : item.type == 'warning' ? 'fas fa-exclamation-circle' : 'fas fa-check-circle'"
    >
      <template v-slot:close>
        <v-icon x-small @click="close(item)">fa-times</v-icon>
      </template>
      {{ item.message }}
    </v-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alerts: []
    }
  },
  created() {
    this.$root.$on('alert', this.open)
  },
  beforeDestroy() {
    this.$root.$off('alert', this.open)
  },
  methods: {
    open(type, message) {
      let item = {alert: false, type: type, message: message}
      this.alerts = [item, ...this.alerts]
      setTimeout(() => {
        item.alert = true
      }, 100)
      setTimeout(() => {
        this.close(item)
      }, 3000)
    },
    close(item) {
      item.alert = false
      setTimeout(() => {
        this.alerts.splice(this.alerts.indexOf(item), 1)
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
.alert {
  position: fixed !important;
  width: 300px;
  left: 0;
  bottom: 0;
  z-index: 9999;
  .v-alert__wrapper {
    align-items: center;
    .v-alert__content {
      display: flex;
    }
    i {
      font-size: 20px !important;
      margin-right: 8px !important;
      align-self: center;
    }
  }
}
</style>